import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
window.$ = window.jQuery = require("jquery");

export default {
    name: "PersonaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "PersonaPage",
            ss: ss,
            ajax: {
                "url": ss.indexPersona(),
                headers: ss.getToken(),
            },
            order: [[0, 'desc']], // Ordenar por id descendente (más recientes primero)
            columns: [
                { data: 'id', name: 'p.id', orderable: true, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'UnidadAcademica', name: 'ua.UnidadAcademica', title: 'Unidad Academica' },
                { data: 'especialidad', name: 'especialidad', title: 'Especialidad' },
                { data: 'Persona', name: 'p.Persona', title: 'Persona' },
                { data: 'email', name: 'p.email', title: 'Correo' },
                { data: 'Rol', name: 'r.Rol', title: 'Rol' },
                /* { data: 'Activo', name: 'p.Activo', title: 'Activo', render: function (data, type, row){
                    if(row.Activo){
                        return '<i class="fa fa-check text-success"> Activo</i>';
                    }else{
                        return '<i class="fa fa-ban text-danger"> Inactivo</i>';
                    }
                }}, */
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            unidadAcademicas: [],
            especialidades: [],
            rols: [],
            personas: [],
            persona: {},
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {},
            busquedaEspecialidad: '',
            especialidadesSeleccionadas: [],
            especialidadTemporal: null,
            indiceEspecialidadActual: null,
        };
    },
    methods: {
        loadFile(input) {
            this.isLoadingFile = true;
            input = event.target;
            if (input.files && input.files[0]) {

                const fileInput = event.target.files[0];
                const fileType = fileInput.type;

                if (!fileType.startsWith('image/')) {

                    this.$swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Solo se permiten archivos de imagen!",
/*                         footer: '<a href="#">Why do I have this issue?</a>'
 */                      });
                    this.isLoadingFile = false;
                    return;
                }

                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                var data = new FormData();
                data.append('File', input.files[0]);
                this.ss.uploadFile(data)
                    .then(result => {
                        if (result.data.success) {
                            this.$bvToast.toast(
                                result.data.msg,
                                {
                                    title: 'Correcto',
                                    variant: 'info',
                                    autoHideDelay: 5000
                                }
                            )
                            this.persona.Foto = result.data.data;
                        } else {
                            this.$bvToast.toast(
                                result.data.msg,
                                {
                                    title: 'Oops!',
                                    variant: 'danger',
                                    autoHideDelay: 5000
                                }
                            )
                        }
                        this.isLoadingFile = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$bvToast.toast(
                            'Error subiendo archivo',
                            {
                                title: 'Oops!',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                        this.isLoadingFile = false;
                    });
            }
        },
        getUnidadAcademica() {
            this.ss.listUnidadAcademica().then(
                (result) => {
                    let response = result.data;
                    this.unidadAcademicas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getUnidadEspecialidad() {
            this.ss.listEspecialidad().then(
                (result) => {
                    let response = result.data;
                    this.especialidades = response;
                    console.log(this.especialidades);
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getRol() {
            this.ss.listRol().then(
                (result) => {
                    let response = result.data;
                    this.rols = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        agregarEspecialidad(esp) {
            // Verificar si ya está seleccionada
            const existe = this.especialidadesSeleccionadas.find(
                e => e.idEspecialidad === esp.idEspecialidad
            );
            if (!existe) {
                this.especialidadesSeleccionadas.push({
                    idEspecialidad: esp.idEspecialidad,
                    Especialidad: esp.Especialidad
                });
            }
            // Limpiar el campo de búsqueda
            this.busquedaEspecialidad = '';
        },
        seleccionarEspecialidadTemporal(esp) {
            this.especialidadTemporal = esp;
        },
        agregarEspecialidadSeleccionada() {
            if (this.especialidadTemporal) {
                // Verificar si ya está seleccionada
                const existe = this.especialidadesSeleccionadas.find(
                    e => e.idEspecialidad === this.especialidadTemporal.idEspecialidad
                );
                if (!existe) {
                    this.especialidadesSeleccionadas.push({
                        idEspecialidad: this.especialidadTemporal.idEspecialidad,
                        Especialidad: this.especialidadTemporal.Especialidad
                    });
                    this.$bvToast.toast(
                        'Especialidad agregada correctamente',
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 3000
                        }
                    );
                } else {
                    this.$bvToast.toast(
                        'Esta especialidad ya fue agregada',
                        {
                            title: 'Aviso',
                            variant: 'warning',
                            autoHideDelay: 3000
                        }
                    );
                }
                // Limpiar selección temporal y campo de búsqueda
                this.especialidadTemporal = null;
                this.busquedaEspecialidad = '';
            }
        },
        // Función para agregar un nuevo campo de especialidad vacío
        agregarCampoEspecialidad() {
            this.especialidadesSeleccionadas.push({
                idEspecialidad: null,
                Especialidad: ''
            });
        },
        // Función para abrir el modal de búsqueda de especialidad
        abrirBuscadorEspecialidad(index) {
            this.indiceEspecialidadActual = index;
            this.busquedaEspecialidad = '';
            this.$refs['modal-buscar-especialidad'].show();
        },
        // Función para seleccionar especialidad desde el modal
        seleccionarEspecialidadModal(esp) {
            const index = this.indiceEspecialidadActual;
            // Verificar si ya está seleccionada en otro campo
            const existe = this.especialidadesSeleccionadas.find(
                (e, i) => e.idEspecialidad === esp.idEspecialidad && i !== index
            );
            if (existe) {
                this.$bvToast.toast(
                    'Esta especialidad ya fue seleccionada en otro campo',
                    {
                        title: 'Aviso',
                        variant: 'warning',
                        autoHideDelay: 3000
                    }
                );
                return;
            }
            // Actualizar el campo con la especialidad seleccionada
            this.$set(this.especialidadesSeleccionadas, index, {
                idEspecialidad: esp.idEspecialidad,
                Especialidad: esp.Especialidad
            });
            this.$refs['modal-buscar-especialidad'].hide();
            this.busquedaEspecialidad = '';
        },
        // Función para actualizar una especialidad cuando se selecciona del typeahead
        actualizarEspecialidad(index, esp) {
            // Verificar si ya está seleccionada en otro campo
            const existe = this.especialidadesSeleccionadas.find(
                (e, i) => e.idEspecialidad === esp.idEspecialidad && i !== index
            );
            if (existe) {
                this.$bvToast.toast(
                    'Esta especialidad ya fue seleccionada en otro campo',
                    {
                        title: 'Aviso',
                        variant: 'warning',
                        autoHideDelay: 3000
                    }
                );
                return;
            }
            // Actualizar el campo con la especialidad seleccionada
            this.especialidadesSeleccionadas[index] = {
                idEspecialidad: esp.idEspecialidad,
                Especialidad: esp.Especialidad
            };
        },
        // Función para limpiar si el usuario borra el texto
        limpiarEspecialidadSiVacio(index, value) {
            if (!value || value.trim() === '') {
                this.especialidadesSeleccionadas[index] = {
                    idEspecialidad: null,
                    Especialidad: ''
                };
            }
        },
        quitarEspecialidad(index) {
            this.especialidadesSeleccionadas.splice(index, 1);
        },
        newPersona() {
            this.persona = {};
            this.especialidadesSeleccionadas = [];
            this.especialidadTemporal = null;
            this.busquedaEspecialidad = '';
            this.$refs['frm-persona'].show();
        },
        showPersona(id) {
            this.isLoading = true;
            this.ss.showPersona(id).then(
                (result) => {
                    let response = result.data;
                    console.log('Especialidades cargadas (JSON):', JSON.stringify(response.data.especialidades));
                    // Primero cargar las especialidades ANTES de asignar la persona
                    // para evitar que el watcher las sobreescriba
                    if (response.data.especialidades && response.data.especialidades.length > 0) {
                        this.especialidadesSeleccionadas = response.data.especialidades.map(e => ({
                            idEspecialidad: e.idEspecialidad,
                            Especialidad: e.Especialidad
                        }));
                        console.log('Especialidades seleccionadas (JSON):', JSON.stringify(this.especialidadesSeleccionadas));
                    } else {
                        this.especialidadesSeleccionadas = [];
                    }
                    // Ahora asignar la persona
                    this.persona = response.data;
                    this.$refs['view-persona'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editPersona() {
            this.$refs['frm-persona'].show();
            this.$refs['view-persona'].hide();
        },
        cancelPersona() {
            if (this.persona.id) {
                this.$refs['view-persona'].show();
            }
            this.$refs['frm-persona'].hide();
        },
        savePersona() {
            if (this.persona.Rol == 1) {
                this.persona.idEspecialidad = null;
            }
            // Agregar especialidades seleccionadas al request
            if (this.persona.Rol == 2) {
                this.persona.especialidadesSeleccionadas = this.especialidadesSeleccionadas;
            }
            this.ss.storePersona(this.persona).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    console.log(response);
                    this.$refs['frm-persona'].hide();
                    this.$refs['datatable-persona'].reload();
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errorBag = error.response.data.errors;
                    } else {
                        this.errorBag = {};
                    }
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePersona() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyPersona(this.persona)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-persona'].hide();
                                this.$refs['datatable-persona'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-persona'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-persona'].show();
        },
        changePassword() {
            this.password.Persona = this.persona.id;
            this.ss.changePassword(this.password)
                .then(result => {
                    let response = result.data;
                    if (response.success) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-persona'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errorBag = error.response.data.errors;
                    } else {
                        this.errorBag = {};
                    }
                })
        },
        draw() {
            window.$('.btn-datatable-persona').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                if (data) {
                    this.showPersona(data);
                } else {
                    this.$bvToast.toast(
                        'Ocurrio un problema inesperado, intente nuevamente.',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                }
            });
        }
    },
    watch: {
        'persona.Rol': function (newVal) {
            // Si el rol cambia a 2 y no hay especialidades, agregar un campo vacío
            if (newVal == 2) {
                // Si no hay ninguna especialidad, agregar un campo vacío
                if (this.especialidadesSeleccionadas.length === 0) {
                    this.especialidadesSeleccionadas.push({
                        idEspecialidad: null,
                        Especialidad: ''
                    });
                }
            }
            // Cuando se cambia a otro rol, limpiar las especialidades
            if (newVal != 2) {
                this.especialidadesSeleccionadas = [];
            }
        }
    },
    components: {
        dataTable,
        Loader,
        VueBootstrapTypeahead,
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            this.getUnidadAcademica();
            this.getUnidadEspecialidad();
            this.getRol();
        }
    }
};
